import * as bootstrap from 'bootstrap';
import * as models from 'smg/customer-api/models';
import * as html from 'smg/html';
import QueryString from 'smg/querystring';
import { FilterEventDetail } from '../components/filters';
import { GalleryMasonry } from '../components/gallery';
import { ModalOrOffcanvas } from '../modal';
import { QuoteModal } from '../quote';

main();

function main() {
    const $imgParents = document.querySelectorAll<HTMLAnchorElement>('.gallery-image-parent');
    const imageDetails = new Map<HTMLElement, Map<string, string>>();
    for (const $imageParent of Array.from($imgParents)) {
        const $img = $imageParent.querySelector('img') as HTMLImageElement;
        const detailsJSON = $img.getAttribute('data-details') || '';
        const details = JSON.parse(detailsJSON) as Record<string, string>;
        details.is3d = details.is3d ? 'Yes' : 'No';

        const detailsMap = new Map<string, string>();
        for (const [key, value] of Object.entries(details)) {
            detailsMap.set(key, value.toLowerCase().replace(/[^a-z0-9'"&()\-%.]+/g, ''));
        }

        imageDetails.set($imageParent, detailsMap);

        $img.addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation(); // Prevent Fancybox from also opening

            QueryString().set('img', $img.getAttribute('data-upload-id')?.concat(`-${html.Anchorize($img.title)}`) || '');

            const productName = (name: string) => {
                switch (name) {
                case 'Challenge Coins':
                    return 'coin';
                case 'Lapel Pins':
                    return 'pin';
                case 'Patches':
                    return 'patch';
                case 'Key Chains':
                case 'Keychains':
                    return 'keychain';
                case 'Lanyards':
                    return 'lanyard';
                case 'Medals':
                    return 'medal';
                case 'Belt Buckles':
                    return 'buckle';
                case '':
                    return 'product';
                default:
                    return name.toLocaleLowerCase();
                }
            };

            const $body = html.FromString(`
            <div class="h-100 d-flex flex-column">
                <div class="flex-grow-1 px-4 px-sm-6 px-md-0">
                    <div id="modal-carousel" class="carousel slide h-100">
                        <div class="carousel-indicators d-md-none">
                            <div class="gallery-carousel-indicators-inner fading-sides px-2">
                                <!-- indicators go here -->
                            </div>
                        </div>
                        <div class="carousel-inner d-flex h-100 align-items-center pb-12">
                            <!-- images go here -->
                        </div>
                    </div>
                </div>

                <div data-bs-theme="blue" class="rounded-top-5 pt-8 px-4 d-md-none">
                    <h3 class="text-center mb-4" id="product-type">Want a ${html.Escape(productName(detailsMap.get('lineItem') ?? ''))} like this?</h3>

                    <div class="d-flex justify-content-center align-items-center gap-2 mb-10 mb-sm-4">
                        <div class="d-sm-none" style="width:2.5rem"></div>
                        <div>
                            <button class="modal-get-a-proof btn btn-outline-primary" type="button">
                                <span class="material-symbols-outlined fs-4">auto_awesome</span>
                                Get a FREE Design
                            </button>
                        </div>
                        <div class="d-sm-none">
                            <button
                                class="modal-what-is-a-proof btn btn-sm btn-outline-primary rounded-circle"
                                type="button">
                                <span class="material-symbols-outlined">help_outline</span>
                            </button>
                        </div>
                    </div>

                    <div class="w-100 text-center d-none d-sm-block mb-10">
                        <a href="#" class="modal-what-is-a-proof text-secondary fw-500 text-decoration-underline">What's a proof?</a>
                    </div>
                </div>

                <div class="d-none d-md-block">
                    <h3 class="text-center mb-4" id="product-type-lg">Want a ${html.Escape(productName(detailsMap.get('lineItem') ?? ''))} like this?</h3>

                    <div class="d-flex align-items-center mb-sm-4">
                        <div style="width:8rem">
                            <button id="modal-prev" class="btn btn-lg btn-link" type="button">
                                <span class="material-symbols-outlined mx-1">chevron_backward</span>
                                Previous
                            </button>
                        </div>
                        <div class="flex-grow-1 text-center">
                            <button class="modal-get-a-proof btn btn-outline-primary" type="button">
                                <span class="material-symbols-outlined fs-4">auto_awesome</span>
                                Get a FREE Design
                            </button>
                        </div>
                        <div id="modal-next" class="text-end" style="width:8rem">
                            <button class="btn btn-lg btn-link" type="button">
                                Next
                                <span class="material-symbols-outlined mx-1">chevron_forward</span>
                            </button>
                        </div>
                    </div>

                    <div class="w-100 text-center d-none d-sm-block mb-10">
                        <a href="#" class="modal-what-is-a-proof fw-500 text-decoration-underline">What's a proof?</a>
                    </div>
                </div>
            </div>`).firstElementChild as HTMLElement;

            const $prev = $body.querySelector<HTMLButtonElement>('#modal-prev');
            $prev?.addEventListener('click', () => {
                carousel.prev();
            });
            const $next = $body.querySelector<HTMLButtonElement>('#modal-next');
            $next?.addEventListener('click', () => {
                carousel.next();
            });

            const $carousel = $body.querySelector('#modal-carousel') as HTMLElement;
            const $indicators = $carousel.querySelector('.carousel-indicators') as HTMLElement;
            const $items = $carousel.querySelector('.carousel-inner') as HTMLElement;

            const $filteredImages = Array.from(document.querySelectorAll('.gallery-image-parent:not(.d-none)')) as HTMLAnchorElement[];

            for (let i = 0; i < $filteredImages.length; i++) {
                const $p = $filteredImages[i];
                const $carouselItem = html.FromString(
                    `<button type="button" data-bs-target="#modal-carousel" data-bs-slide-to="${i}"` +
                    `${$p === $imageParent ? ' class="active"' : ''}></button>`,
                ).firstElementChild as HTMLButtonElement;
                $indicators.querySelector('.gallery-carousel-indicators-inner')?.appendChild($carouselItem);

                const $img = $p.querySelector('img') as HTMLImageElement;
                const webpSrcset = $p.getAttribute('data-srcset-webp') ?? '';
                const $item = html.FromString(`
                <div class="carousel-item ${$p === $imageParent ? 'active' : ''}">
                    <picture class="w-100 d-flex justify-content-center">
                        <source srcset="${html.Escape(webpSrcset)}" type="image/webp">
                        <img src="${html.Escape($p.href)}" class="d-block h-100 w-auto mw-100 rounded-5"
                            alt="${html.Escape($img.title)}"
                            title="${html.Escape($img.title)}"
                            data-details="${html.Escape($img.getAttribute('data-details') ?? '')}"
                            width="${$img.width}" height="${$img.height}"
                            style="max-height: calc(100vh - 35rem);">
                    </picture>
                </div>`).firstElementChild as HTMLElement;
                $items.appendChild($item);
            }

            const carousel = new bootstrap.Carousel($carousel);

            $carousel.addEventListener('slide.bs.carousel', () => {
                setTimeout(() => {
                    const $activeIndicator = $indicators.querySelector('button.active') as HTMLButtonElement;
                    if (!$activeIndicator) {
                        return;
                    }
                    $activeIndicator.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                        inline: 'center',
                    });
                }, 100);
            });

            $carousel.addEventListener('slid.bs.carousel', () => {
                const $heading = carouselModal.element?.querySelector('h2') as HTMLElement;
                const $active = $items.querySelector('.active img') as HTMLImageElement;
                $heading.textContent = $active.title;

                const $headingSm = $body.querySelector('#product-type') as HTMLElement;
                const $headingLg = $body.querySelector('#product-type-lg') as HTMLElement;

                const detailsJSON = $active?.getAttribute('data-details') || '';
                const details = JSON.parse(detailsJSON) as Record<string, string>;

                const productName = (name: string) => {
                    switch (name) {
                    case 'Challenge Coins':
                        return 'coin';
                    case 'Lapel Pins':
                        return 'pin';
                    case 'Patches':
                        return 'patch';
                    case 'Key Chains':
                    case 'Keychains':
                        return 'keychain';
                    case 'Lanyards':
                        return 'lanyard';
                    case 'Medals':
                        return 'medal';
                    case 'Belt Buckles':
                        return 'buckle';
                    case '':
                        return 'product';
                    default:
                        return name.toLocaleLowerCase();
                    }
                };

                const itemType = details?.lineItem || '';
                const headingText = `Want a ${productName(itemType)} like this?`;

                $headingSm.textContent = headingText;
                $headingLg.textContent = headingText;
            });

            // shows a tooltip explaining what a proof is
            const $whatIsAProof = $body.querySelectorAll<HTMLButtonElement>('.modal-what-is-a-proof');
            const $tooltip = html.FromString(
                '<div class="text-body">A proof is a digital representation of your custom product. ' +
                'It\'s a preview of what your product will look like before it\'s made.</div>',
            ).firstElementChild as HTMLElement;
            $whatIsAProof.forEach($ => {
                const t = new bootstrap.Tooltip($, {
                    title: $tooltip,
                    html: true,
                    placement: 'top',
                    trigger: 'click',
                    offset: [0, 24],
                });
                $.addEventListener('blur', () => t.hide());
            });

            const $getAProof = $body.querySelectorAll<HTMLButtonElement>('.modal-get-a-proof');
            $getAProof.forEach($ => $.addEventListener('click', () => {
                const $img = $items.querySelector('.active img') as HTMLImageElement;
                const details = JSON.parse($img.getAttribute('data-details') || '{}') as Record<string, string | number | boolean>;

                carouselModal.close();

                const children: models.QuoteRequestCreateChild[] = [];
                const extras: models.QuoteRequestCreateExtra[] = [];
                for (const key of Object.keys(details)) {
                    if (key === 'invoiceNumber') {
                        extras.push(new models.QuoteRequestCreateExtra({
                            name: 'Sample invoice number',
                            value: String(details[key]),
                        }));
                        continue;
                    }

                    if (key === 'lineItem' || key === 'type' || key === 'size' || key === 'industry' || key === 'manufacturingLocation') {
                        continue;
                    }
                    children.push(new models.QuoteRequestCreateChild({
                        child: key,
                        option: String(details[key]),
                    }));
                }

                QuoteModal({
                    lineItem: String(details.lineItem),
                    type: String(details.type),
                    size: String(details.size),
                    prefixNotes: `I would like something like this ${productName(String(details['lineItem']))} from your gallery: ${$img.src}`,
                    children,
                    extras,

                    form: 'main gallery',
                    backButtonText: 'Back to Gallery',

                    disableCompany: true,
                });
            }));

            const carouselModal = new ModalOrOffcanvas({
                title: $img.title,
                headerLevel: 'h2',
                body: $body,
                appendClassBySelector: {
                    '.offcanvas-body': 'p-0',

                    '.modal-dialog': 'px-8',
                    '.modal-body': 'px-8 pb-0',
                    '.modal-footer': 'd-none',
                },
                onClose: () => {
                    QueryString().delete('img');
                },
            });
        });
    }

    const img = QueryString().get('img')?.split('-')[0];
    if (img) {
        const $img = Array.from($imgParents).find($ => $.querySelector('img')?.getAttribute('data-upload-id') === img);
        if ($img) {
            $img.querySelector('img')?.click();
        } else {
            QueryString().delete('img');
        }
    }

    const filtersQueryString = QueryString().get('filters');
    if (filtersQueryString) {
        const filters: Record<string, string[]> = filtersQueryString.split('|').reduce((acc: Record<string, string[]>, filter) => {
            const [key, value] = filter.split('=');
            acc[key] = value.split('_');
            return acc;
        }, {});

        Object.entries(filters).forEach(([filter, values]) => {
            values.forEach(value => {
                const $checkbox = document.querySelector<HTMLInputElement>(`input[name="${CSS.escape(filter)}"][value="${CSS.escape(value)}"]`);
                if ($checkbox) {
                    $checkbox.checked = true;
                }
            });
        });

        for (const [image, details] of imageDetails) {
            let show = true;

            for (const [filterName, filterValue] of Object.entries(filters)) {
                if (!details.has(filterName) || !filterValue.includes(details.get(filterName) as string)) {
                    show = false;
                    break;
                }
            }

            if (!show) {
                image.classList.add('d-none');
            }
        }

        GalleryMasonry?.reloadItems?.();
        GalleryMasonry?.layout?.();
    }

    document.addEventListener('filterUpdate', ((e: CustomEvent<FilterEventDetail>) => {
        $imgParents.forEach($ => $.classList.remove('d-none'));

        if (!e.detail.filters.length) {
            QueryString().delete('filters');
            GalleryMasonry?.reloadItems?.();
            GalleryMasonry?.layout?.();
            return;
        }

        const filters = new Map<string, Set<string>>();
        for (const filter of e.detail.filters) {
            filters.set(filter.name, new Set(filter.options));
        }

        const map = [...filters.entries()].map(([filter, values]) => `${filter}=${Array.from(values).join('_')}`).join('|');
        QueryString().set('filters', map);

        // an image must have one value of each filter selected to be shown.
        // filter values are OR'd together, and filters are AND'd together.

        for (const [image, details] of imageDetails) {
            let show = true;

            for (const [filterName, filterValue] of filters) {
                if (!details.has(filterName) || !filterValue.has(details.get(filterName) as string)) {
                    show = false;
                    break;
                }
            }

            if (!show) {
                image.classList.add('d-none');
            }
        }

        GalleryMasonry?.reloadItems?.();
        GalleryMasonry?.layout?.();
    }) as EventListener);

    const $filtersPanel = document.querySelector('#filters') as HTMLElement;
    $filtersPanel.click();

    // Ensure images are visible after all initialization
    // The filterUpdate event from filters.ts may have fired before this listener was set up
    setTimeout(() => {
        const hasCheckedFilters = $filtersPanel.querySelectorAll<HTMLInputElement>(':checked').length > 0;
        if (!filtersQueryString && !hasCheckedFilters) {
            $imgParents.forEach($ => $.classList.remove('d-none'));
            GalleryMasonry?.reloadItems?.();
            GalleryMasonry?.layout?.();
        }
    }, 0);

    const $filtersContainer = document.querySelector('#filters-container') as HTMLElement;
    const $galleryImages = document.querySelector('#gallery-images') as HTMLElement;

    window.addEventListener('.filters-hidden', () => {
        $filtersContainer.classList.add('d-lg-none');
        $galleryImages.classList.remove('row-cols-lg-3', 'row-cols-xxl-4');
        $galleryImages.classList.add('row-cols-lg-4', 'row-cols-xxl-5');

        GalleryMasonry?.reloadItems?.();
        GalleryMasonry?.layout?.();
    });

    window.addEventListener('.filters-shown', () => {
        $filtersContainer.classList.remove('d-lg-none');
        $galleryImages.classList.remove('row-cols-lg-4', 'row-cols-xxl-5');
        $galleryImages.classList.add('row-cols-lg-3', 'row-cols-xxl-4');

        GalleryMasonry?.reloadItems?.();
        GalleryMasonry?.layout?.();
    });
}